import React from "react";
import { Link } from "react-router-dom";
import { useAppContext } from "../../../context/AppContext";
import Transition from "../../../components/Transition";
import { AnimatePresence } from "framer-motion";


export default function AuthPageLayout({ children }) {
    const { appData } = useAppContext();
    
    return (
        <div className="vh-100">
            <div className="authincation h-100">
                <div className="container h-100">
                    <AnimatePresence mode="wait">
                    <Transition key={"auth-page"}>
                        <div className="row justify-content-center h-100 align-items-center">
                            <div className="col-md-6">
                                <div className="authincation-content">
                                    <div className="row no-gutters">
                                        <div className="col-xl-12">
                                            <div className="auth-form">
                                                <div className="text-center mb-3">
                                                    <Link to="/"><img className="rounded" src={appData.logo} alt="Logo" width="60" height="60" /></Link>
                                                </div>

                                                {children}

                                                <div className="text-blue-900 font-semibold">
                                                    <p className="text-center py-1 text-[8px] ">
                                                        <Link to={"/Legal"}>
                                                            <span className="md:hover:underline underline-offset-2">
                                                                Legal
                                                            </span>
                                                        </Link>{" "}
                                                        &bull;{" "}
                                                        <Link to={"/help"}>
                                                            <span className="md:hover:underline underline-offset-2">
                                                                Help
                                                            </span>
                                                        </Link>{" "}
                                                        &bull;{" "}
                                                        &copy; {new Date().getFullYear()} {appData?.name}. All rights reserved.
                                                    </p>

                                                    <div className="d-flex py-2 justify-content-center align-items-center gap-4">
                                                        {appData?.socials?.whatsapp && (
                                                            <a
                                                                href={appData.socials.whatsapp}
                                                                target="_blank"
                                                                rel="noopener noreferrer"
                                                                className="text-success fs-4"
                                                            >
                                                                <i className="fab fa-whatsapp"></i>
                                                            </a>
                                                        )}

                                                        {appData?.socials?.telegram && (
                                                            <a
                                                                href={appData.socials.telegram}
                                                                target="_blank"
                                                                rel="noopener noreferrer"
                                                                className="text-info fs-4"
                                                            >
                                                                <i className="fab fa-telegram-plane"></i>
                                                            </a>
                                                        )}

                                                        {appData?.socials?.facebook && (
                                                            <a
                                                                href={appData.socials.facebook}
                                                                target="_blank"
                                                                rel="noopener noreferrer"
                                                                className="text-primary fs-4"
                                                            >
                                                                <i className="fab fa-facebook-f"></i>
                                                            </a>
                                                        )}

                                                        {appData?.socials?.tiktok && (
                                                            <a
                                                                href={appData.socials.tiktok}
                                                                target="_blank"
                                                                rel="noopener noreferrer"
                                                                className="text-danger fs-4"
                                                            >
                                                                <i className="fab fa-tiktok"></i>
                                                            </a>
                                                        )}

                                                        {appData?.socials?.x && (
                                                            <a
                                                                href={appData.socials.x}
                                                                target="_blank"
                                                                rel="noopener noreferrer"
                                                                className="text-dark fs-4"
                                                            >
                                                                <i className="fab fa-twitter"></i>
                                                            </a>
                                                        )}

                                                        {appData?.socials?.instagram && (
                                                            <a
                                                                href={appData.socials.instagram}
                                                                target="_blank"
                                                                rel="noopener noreferrer"
                                                                className="text-danger fs-4"
                                                            >
                                                                <i className="fab fa-instagram"></i>
                                                            </a>
                                                        )}
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </Transition>
                    </AnimatePresence>
                </div>
            </div>
        </div>

    );
}